<template>
  <NoneChevronExpansionPanel>
    <template #header>
      <div class="headerAreaStyle d-flex align-center px-9">
        <div class="titleStyle">{{ $t('sale.sale_history-search') }}</div>
        <div class="ml-5">
          <v-checkbox
            v-model="invalidDisplayFlg"
            :label="$t('common.common_hide-invalid-history')"
          />
        </div>
      </div>
    </template>
    <template #content>
      <div class="mx-5 mb-5 mt-2">
        <div class="pa-2">
          <v-row no-gutters>
            <v-col cols="8">
              <InputFormNew
                :value="inputData"
                :detail="items"
                :titleCols="inputFormStyle.titleCols"
                :contentsCols="inputFormStyle.contentsCols"
              >
                <template #status="{ item }">
                  <div class="d-flex">
                    <v-select
                      v-model="item.status"
                      :items="statuList"
                      item-text="name"
                      item-value="status"
                      dense
                      outlined
                      class="original-selectbox selectboxStyle"
                      hide-details
                      :height="inputFormStyle.inputItemHeight"
                    />
                  </div>
                </template>
              </InputFormNew>
            </v-col>
          </v-row>
        </div>
      </div>
    </template>
  </NoneChevronExpansionPanel>
</template>

<script>
import _cloneDeep from 'lodash/cloneDeep'
import { NoneChevronExpansionPanel } from '@/components/items'
import InputFormNew from '@/components/items/Designs/InputFormNew'
import { commonUtil } from '@/util'
import { i18n } from '@/main.js'

export default {
  components: {
    NoneChevronExpansionPanel,
    InputFormNew
  },
  props: {},
  data: () => {
    return {
      pageTitle: 'CSV履歴',
      invalidDisplayFlg: true,
      inputData: {},
      inputFormStyle: {
        titleCols: 3,
        contentsCols: 7,
        inputItemHeight: '32px'
      },
      items: [
        {
          text: i18n.tc('common.common_upload-date'),
          name: 'uploadDate',
          component: 'FromToDatePicker'
        },
        {
          text: i18n.tc('common.common_select-country-ec'),
          name: 'platformId',
          component: 'SelectPlatform'
        },
        {
          name: 'status',
          text: i18n.tc('common.common_status')
        }
      ],
      // platformData表示用データ
      // platformDataはデータ登録用テーブルがないため、ベタでフロントにデータを記述
      platformData: [
        {
          platformId: 33,
          platformName: '中国EC'
        },
        {
          platformId: 88,
          platformName: '日本EC'
        }
      ]
    }
  },
  created() {
    this.inputData = {
      uploadDate: {
        start: commonUtil.getFirstDateOneMonthAgo(),
        end: commonUtil.getLastDateThisMonth()
      },
      platformId: {},
      status: 0
    }
  },
  computed: {
    statuList() {
      return [
        { name: this.$t('common.common_overall'), status: 0 },
        { name: this.$t('common.common_valid'), status: 1 },
        { name: this.$t('common.common_invalid'), status: 2 }
      ]
    }
  },
  methods: {
    updateInput(item) {
      this.$emit('updateInput', item)
    }
  },
  watch: {
    inputData: {
      deep: true,
      handler(newVal) {
        this.$emit('updateInput', newVal)
      }
    },
    invalidDisplayFlg(newVal) {
      this.$emit('invalidDisplayFlg', newVal)
    }
  }
}
</script>

<style scoped lang="scss">
.titleStyle {
  font-size: 18px;
  font-weight: bold;
}
.headerAreaStyle {
  height: 70px;
}
// label > input {
//   display: none;
// }
// label {
//   padding: 5px 10px;
//   border-radius: 4px;
//   border: solid 1px #c8cfd7;
//   background-color: #fff;
// }
.selectboxStyle {
  max-width: 261px;
}
// .textButtonStyle {
//   margin: 0px 21px;
//   ::v-deep .v-btn {
//     font-size: 12px;
//   }
// }
// .uploadResultTextButtonStyle {
//   ::v-deep .v-btn {
//     padding: 0;
//     font-size: 14px;
//   }
// }
</style>
